import { forwardRef, useEffect, useState } from "react";
import ImageReaderFooter from "../image/footer";

interface PreviewSvgProps {
    src: string;
    name?: string;
}

const SVGReader = forwardRef(({ src, name }: PreviewSvgProps, ref: any) => {
    const [scale, setScale] = useState<number>(1);
    let svgImage = document.getElementById("svgImage");

    useEffect(() => {
        if (svgImage) {
            svgImage.style.transform = `scale(${scale})`;
            svgImage.style.transition = `transform 1s`;
        }
    }, [src, scale]);

    return (
        <>
            {src && <img id="svgImage" src={src} alt={name} ref={ref} style={{ transition: "transform 0s ease-in" }} />}
            <ImageReaderFooter scale={scale} setScale={setScale} />
        </>
    );
});

export default SVGReader;
